import React, { FC, HTMLAttributes } from 'react';
import '../constants/const.css';

interface FormInputProps<T> extends HTMLAttributes<HTMLInputElement | HTMLSelectElement> {
  formValueState: [T, React.Dispatch<React.SetStateAction<T>>];
  'data-key': number[];
  children: any;
  resolveValue?: (value: any, inputValue: any, element: HTMLElement) => any;
}
/**
 * 指定されたStateオブジェクトと対応するキーから子要素の入力値を同期更新する
 * この要素の属性値はidなどの一部例外を除き、子要素にコピーされる
 */
const FormInput: FC<FormInputProps<any>> = (props) => {
  /**
   * 入力要素のイベントに対してフォーム入力値のStateの値を同期させる
   * @param e HTMLイベントオブジェクト
   */
  function handleValuesCommon(e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) {
    const [formValues, setFormValues] = props.formValueState;

    let { value, dataset } = e.target;

    const inputValue = value;

    const keys = (typeof dataset?.key === 'string' ? dataset.key : '').split(',').map((key) => Number(key));
    console.log('handleValue', [e.type, dataset?.key, keys, value]);

    const _index = keys.shift();
    const index = typeof _index === 'undefined' ? -1 : _index;
    const propKey: string = Object.keys(formValues)[index];

    console.log('propKey', [propKey, typeof formValues[propKey]]);

    const resolveValue = (value: any) => {
      return props.resolveValue ? props.resolveValue(value, inputValue, e.target) : value;
    };

    // 2番目以降のキーは配列プロパティに対する添字とみなす
    if (keys.length) {
      let arrayRef = (formValues as any)[propKey];
      let terminateDimentionRef = (formValues as any)[propKey];
      while (keys.length > 1) {
        const index = keys.shift();
        console.log(index);
        terminateDimentionRef = terminateDimentionRef[typeof index === 'undefined' ? -1 : index];
      }
      const terminateDimentionIndex = keys.shift();
      terminateDimentionRef[typeof terminateDimentionIndex === 'undefined' ? -1 : terminateDimentionIndex] = resolveValue(value);
      console.log(terminateDimentionRef);

      // ここでは引数"value"は配列の要素の値なので、その配列全体をプロパティにセットさせる
      // また、配列要素の値が変わるだけではリアクティブが効かないのでコピーされた別の配列の参照をセットする
      value = arrayRef.concat();
    }
    let newFormValues = {
      ...formValues,
      [propKey]: resolveValue(value),
    };

    setFormValues(newFormValues);
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
    handleValuesCommon(e);
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const children = React.Children.map(props.children, (child) => {
    return React.cloneElement(child, { ...props, children: child.props.children, onChange });
  });

  return <span>{children}</span>;
};

export default FormInput;
